import React from 'react'
import StatusContext from '../../../contexts/StatusContext'
import { Delete, ArrowUpward, ArrowDownward} from "@mui/icons-material"
import { useState, useEffect, useRef } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { AlertDialog } from '../alertdialog/AlertDialog'
import {ScrollText} from "../scrolltext/ScrollText"
import Stack from '@mui/material/Stack'
import "./prompt.css"

let promptid = -1

const Prompt = ({ prompt, onDelete, onChange, onChangeWho, onMoveUp, onMoveDown,  onEdit, disableMoveUp, disableMoveDown, seqid, total }) => {

  const [confirmDelete, setConfirmDelete] = useState(false);
 
  let {
    isLoading,
    changeLanguage,
} = React.useContext(StatusContext);


const promptAreaRef = useRef(null);

useEffect(() => {
  
  if (promptAreaRef.current) {
    promptAreaRef.current.style.height = 'auto';
    promptAreaRef.current.style.height = `${promptAreaRef.current.scrollHeight}px`;
  }
  
  
}, [prompt.what,  promptAreaRef]);


const onDeletePrompt = (id) => {
  promptid = id
  setConfirmDelete(true)
}

const alertYes = () => {
  console.log("AlertYes", promptid)
  onDelete(promptid)
  closeDialogBox()
}

const alertCancel = () => {
  console.log("AlertCancel")
  closeDialogBox()
}

const closeDialogBox = () => {
  setConfirmDelete(false)
}


  return (
    <div>
       <div className='themeModule'>
       <div style={{ fontSize: '14px' }}>

    
           <Stack direction="row" spacing={0}>
          {
            <label ><span style = {{paddingRight:'5px', color:'maroon', fontWeight:'500',fontSize:'12px'}}>({seqid}/{total})</span></label>
          }         
        
       
          <ArrowUpward className="promptIcon" style={
            {
              cursor: disableMoveUp ? 'undefined' : 'pointer',
              pointerEvents: disableMoveUp ? 'none' : 'all',
              opacity: disableMoveUp ? 0.5 : 1
            }
          } onClick={() =>{ !isLoading && onMoveUp(prompt.id)}} />

          <ArrowDownward className="promptIcon" style={
            {
              cursor: disableMoveDown ? 'undefined' : 'pointer',
              pointerEvents: disableMoveDown ? 'none' : 'all',
              opacity: disableMoveDown ? 0.5 : 1
            }   
          } onClick={() => { !isLoading && onMoveDown(prompt.id)}} />
          
          <EditIcon className="promptIcon"  onClick={() => {  !isLoading && onEdit(prompt) }} />
          <Delete className="promptIcon" onClick={() => {  !isLoading && onDeletePrompt(prompt.id) }} />
        </Stack>

 </div>
      <div className='promptWhoContainer'>
       
            <div className="promptWho" >{prompt.who} </div>
     
     </div>

    <div>
      
      <ScrollText text={prompt.what} onChange={event => onChange(prompt.id, event)}/>
    
    </div>

    </div>
    <br></br>
    <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {confirmDelete} closeDialog = {closeDialogBox} prompt={changeLanguage('dialog', 'deletetemplatestep')}/>
    </div>
  )
}

export default Prompt